const NAMESPACE = "extractorWarningDialog";

const KEYS = {
    extractorWarningDialogFailedFieldsMessage: "extractorWarningDialogFailedFieldsMessage"
};

const MESSAGES = {
    [KEYS.extractorWarningDialogFailedFieldsMessage]: {
        value: "Failed to extract data from the uploaded document for the following field(s):",
        comment: "Message in extractor warning dialog for fields that the extractor failed to write to"
    }
};

export { KEYS, NAMESPACE, MESSAGES };
